var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseFieldWrapper',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(ref){
var vuelidateIns = ref.vuelidateIns;
var value = ref.value;
var listeners = ref.listeners;
var attrs = ref.attrs;
return [_c('textarea',_vm._g(_vm._b({ref:"input",staticClass:"form-control",class:[vuelidateIns && 'border-danger', _vm.warning && 'border-warning'],attrs:{"aria-describedby":"addon-right addon-left"},domProps:{"value":value}},'textarea',attrs,false),listeners))]}}])},'BaseFieldWrapper',Object.assign({}, _vm.$props, _vm.$attrs),false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }